import React, { useCallback, useEffect, useState } from "react";
import { Button, Space, Table, Tag, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { functionService } from "../../lib/functions";
import Sidemenu from "../../components/sidemenu";
import * as Styled from "./styled";

const listErrorMessage = (result, fallback) =>
    result?.error?.response?.data?.meta?.message || result?.error?.message || fallback;

export default function BashQuestions() {
    const navigate = useNavigate();
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchQuestions = useCallback(async () => {
        setLoading(true);
        const filters = await functionService.get("assessments/getfilterlist");
        if (!filters?.status) {
            setLoading(false);
            message.error(listErrorMessage(filters, "Couldn't load bash questions."));
            return;
        }
        const types = filters.response?.data?.data?.question_type || [];
        const bashType = types.find((t) => String(t.question_type_code).toUpperCase() === "BASH");
        if (!bashType?.id) {
            setLoading(false);
            setQuestions([]);
            return;
        }

        const result = await functionService.get(
            `assessments/getallquestions?owners=COFFEEE&question_type_id=${bashType.id}`
        );
        setLoading(false);
        if (!result?.status) {
            message.error(listErrorMessage(result, "Couldn't load bash questions."));
            return;
        }
        const rows = Array.isArray(result.response?.data?.data) ? result.response.data.data : [];
        setQuestions(rows.filter((q) => String(q.question_type_code || "").toUpperCase() === "BASH"));
    }, []);

    useEffect(() => {
        fetchQuestions();
    }, [fetchQuestions]);

    const columns = [
        {
            title: "Title",
            dataIndex: "title",
            render: (title, q) => (
                <Space direction="vertical" size={0}>
                    <span style={{ fontWeight: 600 }}>{title || "Untitled"}</span>
                    <Styled.Mono style={{ color: "#94a3b8" }}>{q.question_id}</Styled.Mono>
                </Space>
            ),
        },
        {
            title: "Status",
            dataIndex: "active",
            width: 110,
            render: (active) =>
                active === false ? <Tag>Inactive</Tag> : <Tag color="green">Active</Tag>,
        },
        {
            title: "Created",
            dataIndex: "created_at",
            width: 200,
            render: (d) => (d ? new Date(d).toLocaleString() : "—"),
        },
        {
            title: "",
            width: 120,
            render: (_, q) => (
                <Button size="small" onClick={() => navigate(`/assessment-question/edit/${q.question_id}`)}>
                    Edit
                </Button>
            ),
        },
    ];

    return (
        <Styled.MainDiv>
            <Sidemenu />
            <Styled.ContentWrapDiv>
                <Styled.TopContainer>
                    <div>
                        <div className="page-title">Bash Questions</div>
                        <div className="page-subtitle">
                            Shell-scripting lab questions. Add a question, upload the folder, and run the
                            grader check before saving.
                        </div>
                    </div>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => navigate("/assessment-question/add")}
                    >
                        Add question
                    </Button>
                </Styled.TopContainer>

                <Styled.Card>
                    <Table
                        rowKey="question_id"
                        loading={loading}
                        columns={columns}
                        dataSource={questions}
                        locale={{ emptyText: "No bash questions yet" }}
                        pagination={{ pageSize: 20, hideOnSinglePage: true }}
                    />
                </Styled.Card>
            </Styled.ContentWrapDiv>
        </Styled.MainDiv>
    );
}
